export default "__VITE_ASSET__BUxTtDR3__"